import axios from "axios";

/**
 * Base URL should include the `/api` prefix, e.g. `http://localhost:3000/api`.
 * Paths in feature modules are relative to that (e.g. `/users/contact-us`).
 */
export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? "http://localhost:3000/api",
  headers: {
    "Content-Type": "application/json",
  },
});
